/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FlagRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABo0lEQVR4nO2WzUrDcAzAhxdPQ0FFxYcQfANRsLjmo0KbDBFvnpyH6cWDDARB7x70EfQJBEVhY++iiPPgYfgBk3Qr1Nl9dEMPYiDQ5p/m1+T/T9pM5rcEWKtIUkla87z1WcRgGT3dAZJTZD0G0OlUAGRtmLokS2EgljMDIkstWosrsN4OBOhXgfQjKc6q78/4vj82NABj2SLreTxbIH0Flq2hAdhV5fGHAdr4BzT+eomklhoApE9A8hALcg8kBzkvmHccZxQRs64XLAALEW2OdwSEgVjLNi6AtGANZR1qfkC6G/qRXCR2bCeJgkeBEn0wWESSOpJelkqlkRDoqQMsV1YSIH1B1huiYOXb8EzcmJgAyxqyvoclQsyaDVkP+97oXgDXzU8i6xGwBnZPlF9tllPekKVo67mcPwes+01bSkC7AOt1a6OLMVt14AzaxQ6C+dubR7bmRI0dFtbywABsjWbmjYk+H0hdorv2EnUHkFS+pNTLHxWjTXZJ9uwb7fj+VHjN8gws2/3G6gxhOenS9YWhASY2FuwHIDyaJHU7XdZ8kcMnjzhl785WW3wAAAAASUVORK5CYII=)
 */
export const FlagRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M12.45 16.53a.16.16 0 0 1-.12.1 2 2 0 0 1-1.78-.6c-.2-.21-.08-.54.18-.68a5.01 5.01 0 0 0 1.94-1.94c.18-.32-.1-.66-.46-.6L4 14.18V21a1 1 0 1 1-2 0V2a1 1 0 0 1 2 0v.82l8.67-1.45A2 2 0 0 1 15 3.35v1.47l5.67-.95A2 2 0 0 1 23 5.85v5.65c0 .28-.23.5-.5.54-.3.05-.58.15-.85.28a.58.58 0 0 1-.44.04 7 7 0 0 0-8.76 4.17Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
